exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Droid+Sans:400,700|Droid+Serif);", ""]);

// module
exports.push([module.id, "", ""]);

// exports
exports.locals = {
	"fontFamily": "'Open Sans', helvetica, sans-serif",
	"bodyFont": "400 14px/14px 'Open Sans', helvetica, sans-serif",
	"headerFont": "700 16px/16px 'Open Sans', helvetica, sans-serif"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":false}!./app/styles/fonts.css
// module id = 174
// module chunks = 0